import type { DependencyType } from '@/lib/api/types/items';

export const SchedulingValidation = {
  MissingTeam: 'MISSING_TEAM',
  EmptyTeam: 'EMPTY_TEAM',
  NoAvailability: 'NO_AVAILABILITY',
  TeamUnavailable: 'TEAM_UNAVAILABLE',
  MissingEstimation: 'MISSING_ESTIMATION',
  InvalidTargetDates: 'INVALID_TARGET_DATES',
  ItemIsDone: 'ITEM_IS_DONE',
  ParentUnschedulable: 'PARENT_UNSCHEDULABLE',
  DependencyUnschedulable: 'DEPENDENCY_UNSCHEDULABLE',
  CircularDependency: 'CIRCULAR_DEPENDENCY',
  OutsideCalendarLimits: 'OUTSIDE_CALENDAR_LIMITS',
} as const;

export type SchedulingValidation = (typeof SchedulingValidation)[keyof typeof SchedulingValidation];

export const TIMELINE_ITEM_IMPUTED_FIELD = {
  ESTIMATION: 'ESTIMATION',
  TEAM: 'TEAM',
} as const;

export type TimelineItemImputedField =
  (typeof TIMELINE_ITEM_IMPUTED_FIELD)[keyof typeof TIMELINE_ITEM_IMPUTED_FIELD];

export interface ScenarioItem {
  organizationId: number;
  scenarioId: number;
  itemId: number;
  teamId: number | null;
  earliestStartDateTime: string | null;
  deadlineDateTime: string | null;
  estimationId: number | null;
  itemStatusId: number;
  itemTypeId: number;
  parentId: number | null;
  priority: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  schedulingValidations: SchedulingValidation[] | null;
  imputedFields: TimelineItemImputedField[] | null;
  dependencies?: TimelineItemItemDependency[] | null;
}

export interface ScenarioItemPatchRequest {
  teamId?: number | null;
  estimationId?: number | null;
  earliestStartDateTime?: string | null;
  deadlineDateTime?: string | null;
  beforeId?: number;
  afterId?: number;
}

export interface ScenarioItemMetrics {
  forecastedStart: string;
  forecastedFinish: string;
  latestFinishDate: string;
  totalWorkItemsCount: number;
  plannedWorkItemsCount: number;
}

export interface TimeLineDataSet {
  itemId: number;
  parentId: number | null;
  matched: boolean;
  isDeletedInItemStore: boolean;
  satisfiesPlanFinishDate: boolean;
  hasChildrenOutsidePlanFinishDate: boolean;
}

export interface TimelineItemItemDependency {
  dependencyType: DependencyType;
  dependencyItemId: number;
}

interface BulkFetchScenarioItem extends ScenarioItem {
  name: string;
}

interface BulkFetchTimelineItemItem {
  itemId: number;
  dependencies: TimelineItemItemDependency[];
}

export interface BulkFetchTimelineItem {
  scenarioItem: BulkFetchScenarioItem;
  item: BulkFetchTimelineItemItem;
  scenarioItemMetrics: ScenarioItemMetrics | null;
}
